export const BASE_URL = 'http://localhost:5000';
